import React from 'react';
import FooterLogo from './../../assets/logos/footerLogo.svg';
import './Auth.css';

function AuthSideContent({ backgroundImage }) {
  return (
    <div
      className="auth-background"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="auth-overlay2"></div>
      <div className="auth-overlay"></div>
      <div className="auth-logo">
        <img
          src={FooterLogo}
          alt="Riso Logo"
          className="auth-logo-image"
        />
      </div>
    </div>
  );
}

export default AuthSideContent;
